/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from './app.service';
import { IceNavService } from '../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../icemedx-lib/src/services/domain/domain.service';
import { PatientService } from '../../../icemedx-lib/src/services/patient/patient.service';
import {
  IcecontrolSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
} from '../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../icemedx-lib/src/login/login.config';
import { IceTypes } from '../../../icemedx-lib/src/models/icetypes';
import { BaseListView } from '../../../icemedx-lib/src/components/baseview.component';
import { BaseAppService } from '../../../icemedx-lib/src/services/baseapp.service';
import { IIceEntity } from '../../../icemedx-lib/src/models/core/IceEntity';
import { Iceutility } from '../../../icemedx-lib/src/services/iceutility';

const SearchKeyword = "SearchKeyword";

export class BasesearchComponent extends BaseListView {
  private ctrlSearchInput: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "450px" }, null, null, SearchKeyword, "Enter Name or Member Number")
    .setControlName(SearchKeyword)
    .createFormControl("", [Validators.required]);
  private ctrlSearchSubmit: IcecontrolSettings = new IcecontrolSettings("icesubmitbutton", { class: "fas fa-paper-plane", width: "50px", text: "Search" }, null, null, "searchSubmit");
  private searchItemPanel: IcepanelSettings = this.createSearchItemPanel();

  constructor(appSvc: AppService,
    loginSvc: LoginService,
    navSvc: IceNavService,
    router: Router,
    private domSvc: DomainService,
    private ptSvc: PatientService,
    private activatedRoute: ActivatedRoute,
    viewName: string) {
    super(<BaseAppService>appSvc, loginSvc, navSvc, router);

    let feaAccess = appSvc.getPermission(userTypes.USER_FEATURES.ufDemographics).default_access;
    appSvc.defaultMenus();
    this.nameOfView = viewName;
    appSvc.addBreadcrumb(this.nameOfView, {}, true, "");

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      setTimeout(function () {
        domSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
      return;
    }

    this.activatedRoute.params.subscribe(next => {
      this.setInlineEditing(true);
      if (next == null || next.key == null || next.key == "0" || next.length == 0) {
        this.dataViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufDemographics);
        this.refreshTableData([]);
      }
      else {
        this.dataViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufDemographics);
        this.doSearch(next.key);
      }
    });
  }

  doSearch(keyword: string) {
  }

  getDomainService(): DomainService {
    return this.domSvc;
  }

  getPatientService(): PatientService {
    return this.ptSvc;
  }

  getActivatedRoute(): ActivatedRoute {
    return this.activatedRoute;
  }

  getSearchItemFormGroup(): FormGroup {
    if (this.searchItemPanel == null)
      return null;

    let formGrp: FormGroup = this.searchItemPanel.getForm();
    try {
      if (formGrp == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  createSearchItemPanel(): IcepanelSettings {
    let panel: IcepanelSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];

      controls.push(
        this.ctrlSearchInput,
      );
      headerControls.push(
        this.ctrlSearchSubmit,
      );

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("SearchItemSection", { class: [""], styles: { width: "100%" } }, null, controls, [])
      ];
      panel = new IcepanelSettings("SearchItemPanel", Iceutility.guid(false), "", "", sections, headerControls)
        .enableForm();

      this.ctrlSearchInput.setOptions([{ value: "", name: "" }]);
    }
    catch (e) {
      console.log(e);
    }
    return panel;
  }

  private getSearchElementValue(): string {
    let ret = "";
    let frmKeyword: FormControl = this.ctrlSearchInput.getFormControl();
    if (Iceutility.isdefined(frmKeyword)) {
      let keywordElem = <HTMLInputElement>document.getElementById(SearchKeyword);
      if (keywordElem) {
        if (keywordElem.value.length == 0) {
          this.domSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: No search keyword entered.");
          return ret;
        }
        ret = keywordElem.value;
      }
    }
    return ret;
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  isRowSelectionEnabled(): boolean {
    return true;
  }

  /////////////////////////////////////
  // Events
  searchSubmitClick(event) {
    let currentSearchKeyword = this.getSearchElementValue();
    if (currentSearchKeyword == "" || currentSearchKeyword.length == 0) return;

    this.doSearch(currentSearchKeyword);
  }
}
